<template>
  <div class="main-layout">
    <!-- 左侧导航栏 -->
    <div class="sidebar">
      <div class="logo-container">
        <img src="../assets/logo.png" alt="新疆音线" class="logo">
        <div class="logo-text">新疆音线</div>
      </div>
      
      <div class="nav-menu">
        <div 
          v-for="item in menuItems" 
          :key="item.id"
          class="nav-item" 
          :class="{ active: currentActiveMenu === item.key }"
          @click="changeMenu(item.key)"
        >
          {{ item.name }}
        </div>
      </div>
      
      <div class="bottom-menu">
        <div 
          class="nav-item" 
          :class="{ active: currentActiveMenu === 'parental-control' }"
          @click="changeMenu('parental-control')"
        >
          家长监护
        </div>
        <div 
          class="nav-item" 
          :class="{ active: currentActiveMenu === 'dispute-resolution' }"
          @click="changeMenu('dispute-resolution')"
        >
          纠纷处理
        </div>
        <div 
          class="nav-item" 
          :class="{ active: currentActiveMenu === 'minor-protection' }"
          @click="changeMenu('minor-protection')"
        >
          未成年人防沉迷
        </div>
        <div 
          class="nav-item" 
          :class="{ active: currentActiveMenu === 'about-us' }"
          @click="changeMenu('about-us')"
        >
          关于我们
        </div>
        <div 
          class="nav-item" 
          :class="{ active: currentActiveMenu === 'contact-us' }"
          @click="changeMenu('contact-us')"
        >
          联系我们
        </div>
        <div class="license">
          <div>备案号：新ICP备2025020370号-1</div>
          <div>公安备案：新公网安备65010602001027号</div>
        </div>
      </div>
    </div>
    
    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 顶部导航 -->
      <div class="top-nav">
        <div class="platform-links">
          <a href="https://www.12377.cn/" target="_blank" class="platform-item">
            <img src="../assets/platform-icon.png" alt="中国互联网举报中心" class="platform-icon">
            <span>中国互联网举报中心</span>
          </a>
          <a href="https://www.xjwljb.com/home" target="_blank" class="platform-item">
            <img src="../assets/platform-icon.png" alt="新疆互联网举报中心" class="platform-icon">
            <span>新疆互联网举报中心</span>
          </a>
          <a href="javascript:void(0)" class="platform-item" @click="changeMenu('report-center')">
            <span>新疆音线网络举报中心</span>
          </a>
        </div>
        <!-- 登录按钮或用户头像 -->
        <div v-if="userInfo" class="user-section">
          <user-avatar :userInfo="userInfo" @logout="$emit('logout')" @view-profile="$emit('view-profile')" />
        </div>
        <div v-else class="login-btn" @click="goToLogin">登录/注册</div>
      </div>
      
      <!-- 内容区域 -->
      <div class="content-area">
        <slot></slot>
      </div>
      
      <!-- 底部备案信息 -->
      <div class="footer">
        <div class="company">新疆音线信息科技有限公司</div>
        <div class="license-info">
          <span style="display: flex;align-items: center;">
            <img style="width: 15px;height: 15px;margin-right: 2px;" src="../assets/icp.png" alt="" srcset="">
            
            <a target="_blank"  style="text-decoration: none;color: #999;" href="https://beian.miit.gov.cn/#/Integrated/index">备案号：新ICP备2025020370号-1</a></span>
          <span style="display: flex;align-items: center;">
            <!-- 图标 -->
             <img style="width: 15px;height: 15px;margin-right: 2px;" src="../assets/备案图标.png" alt="" srcset="">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=65010602001027"  style="text-decoration: none;color: #999;"  rel="noreferrer" target="_blank">公安备案：新公网安备65010602001027号</a >
          
          </span>
        </div>
      </div>
    </div>
    
    <!-- 浮动音频播放器 -->
    <floating-audio-player ref="floatingPlayer" />
  </div>
</template>

<script>
import { getUserDetail } from '../api';
import UserAvatar from './UserAvatar.vue';
import FloatingAudioPlayer from './FloatingAudioPlayer.vue';

export default {
  name: 'MainLayout',
  components: {
    UserAvatar,
    FloatingAudioPlayer
  },
  props: {
    defaultActiveMenu: {
      type: String,
      default: 'home'
    },
    currentMenu: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      userInfo: null,
      loading: false,
      currentActiveMenu: this.currentMenu,
      menuItems: [
        { id: 0, key: 'home', name: '首页', type: '首页', categoryId: 0 },
        // { id: 80, key: 'mv', name: 'MV', type: 'MV', categoryId: 80 },
        { id: 53, key: 'singer', name: '歌手', type: '歌手', categoryId: 53 },
        // { id: 100, key: 'all', name: '全部', type: '全部', categoryId: 100 }
      ]
    }
  },
  computed: {
    activeMenu() {
      // 使用父组件传递的currentMenu
      return this.currentMenu;
    }
  },
  watch: {
    // 监听父组件传递的currentMenu变化
    currentMenu(newValue) {
      this.currentActiveMenu = newValue;
    }
  },
  created() {
    // 检查是否有token
    const token = localStorage.getItem('token');
    if (token) {
      // 获取用户信息
      this.fetchUserInfo();
    }
  },
  methods: {
    changeMenu(menu) {
      this.currentActiveMenu = menu;
      
      // 查找对应的分类ID
      let categoryId = null;
      if (menu === 'home' || menu === 'mv' || menu === 'singer' || menu === 'all') {
        const menuItem = this.menuItems.find(item => item.key === menu);
        if (menuItem) {
          categoryId = menuItem.categoryId;
        }
      }
      
      this.$emit('menu-change', menu, categoryId);
    },
    goToLogin() {
      // 通知App组件显示登录模态框
      this.$emit('show-login');
    },
    async fetchUserInfo() {
      this.loading = true;
      try {
        const res = await getUserDetail();
        if (res.rc === 1 && res.data) {
          this.userInfo = res.data;
          // 缓存用户信息
          localStorage.setItem('userInfo', JSON.stringify(res.data));
        } else {
          // 获取用户信息失败，可能是token过期
          console.error('获取用户信息失败:', res.msg);
          // 尝试从本地缓存获取
          const cachedUserInfo = localStorage.getItem('userInfo');
          if (cachedUserInfo) {
            this.userInfo = JSON.parse(cachedUserInfo);
          }
        }
      } catch (error) {
        console.error('获取用户信息出错:', error);
        // 尝试从本地缓存获取
        const cachedUserInfo = localStorage.getItem('userInfo');
        if (cachedUserInfo) {
          this.userInfo = JSON.parse(cachedUserInfo);
        }
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.main-layout {
  display: flex;
  min-height: 100vh;
  background-color: #f5f5f5;
  position: relative;
}

.sidebar {
  width: 150px;
  background-color: #fff;
  border-right: 1px solid #eee;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  height: 100vh;
  overflow-y: auto; /* 如果内容过多，允许滚动 */
}

.logo-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.logo {
  width: 60px;
  height: 60px;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.logo-text {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  background: linear-gradient(90.00deg, rgb(150, 33, 254),rgb(26, 123, 238));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.nav-menu {
  padding: 20px 0;
}

.nav-item {
  padding: 12px 20px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 16px;
  /* color: #999; */
  color: rgba(1, 1, 1, 0.5);

}

.nav-item:hover {
  background-color: #f5f5f5;
  color: #000;
}

.nav-item.active {
  color: #000;
  font-weight: 500;
}

.bottom-menu {
  padding: 20px 0;
  border-top: 1px solid #f0f0f0;
  margin-top: auto;
}

.bottom-menu .nav-item {
  font-size: 14px;
  padding: 8px 20px;
  /* color: rgba(1, 1, 1, 0.5); */
}

.license {
  padding: 10px 20px;
  font-size: 12px;
  color: rgba(1, 1, 1, 0.5);
  line-height: 1.5;
  word-break: break-all;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  margin-left: 150px; /* 与sidebar宽度相同 */
  min-height: 100vh;
  position: relative;
  padding-bottom: 60px; /* 为footer预留空间 */
  padding-top: 50px; /* 为top-nav预留空间 */
}

.top-nav {
  height: 50px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 150px; /* 与sidebar宽度相同 */
  right: 0;
  z-index: 99;
}

.platform-links {
  display: flex;
  align-items: center;
}

.platform-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
  font-size: 14px;
  color: #666;
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s;
  border: 1px solid #f5f5f5;
}

.platform-item:hover {
  background-color: #f5f5f5;
  color: #333;
}

.platform-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  border-radius: 4px;
}

.login-btn {
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.login-btn:hover {
  color: #4169e1;
}

.user-section {
  display: flex;
  align-items: center;
}

.content-area {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.footer {
  height: 60px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eee;
  position: fixed;
  bottom: 0;
  left: 150px; /* 与sidebar宽度相同 */
  right: 0;
  z-index: 99;
}

.company {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.license-info {
  font-size: 14px;
  color: #999;
  align-items: center;
  justify-content: center;
  display: flex;
}

.license-info span {
  margin: 0 10px;
}
</style> 